import { useEffect } from "react";
import { Button } from "@repo/ui";
import { BrandCreationHeader } from "./brand-creation-header/brand-creation-header";
import { useCreateBrand } from "./use-create-brand";
import { BrandPathsControl } from "../brand-paths-control/brand-paths-control";
import { useBrandCreationContext } from "../contexts/brand-creation-context-provider";

type Props = {
  onClose?: () => void;
};

export const BrandCreation = ({ onClose }: Props) => {
  const { state, addBrandPath, updateBrandPath, removeBrandPath } = useBrandCreationContext();
  const { brandName, selectedCustomerId, brandPaths } = state;
  const { createBrand, isPending, isSuccess } = useCreateBrand();
  useEffect(() => {
    if (isSuccess && onClose) {
      onClose();
    }
  }, [isSuccess, onClose]);
  return (
    <div className="card-border flex w-full flex-col">
      <BrandCreationHeader />
      <div className="flex flex-col gap-8 p-5">
        <BrandPathsControl
          brandPaths={brandPaths}
          addBrandPath={addBrandPath}
          updateBrandPath={updateBrandPath}
          removeBrandPath={removeBrandPath}
        />
        <div className="flex justify-end gap-4">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={isPending || !brandName || !selectedCustomerId} onClick={createBrand}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
